// ---- Amplify Imports ------------------------------------------------------------------
import { Amplify } from "aws-amplify";
import {
  Authenticator,
  ThemeProvider,
} from "@aws-amplify/ui-react";

import "@aws-amplify/ui-react/styles.css";
import config from "./aws-exports";
// ---- Library Imports -------------------------------------------------------------------
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import "./App.scss";
import Home from "./views/home";
import { LoginHeader } from "./components/amplifyLoginPage/header/loginHeader";
import { Header } from "./components/amplifyLoginPage/header/header";
import "./components/amplifyLoginPage/styles_light.scss";
import { LoginFooter } from "./components/amplifyLoginPage/footer/loginFooter";
import { darkModeTheme, lightModeTheme } from "./components/amplifyLoginPage/themes/themes";
import SubscriptionSettings from "./views/subscriptionSettings";
import MFASettings from "./views/mfaSettings";
import EquipmentHealthSubscriptionSettings from "./views/equipmentHealthSubscriptionSettings";
import { useTranslation } from 'react-i18next';
import { canViewEquipmentHealth } from "./utilities/utils";

// ---- Configure App --------------------------------------------------------------------
Amplify.configure({
  ...config,
  "oauth":{//overwrite redirectSignIn and redirectSignOut to be exact url that be used in sso flow
    ...config.oauth,
    "redirectSignIn": `${process.env.REACT_APP_BASE_URL}/home`,
    "redirectSignOut": `${process.env.REACT_APP_BASE_URL}`
 }
});

export default function App() {
  const { t } = useTranslation('common');
  const formFields = {
  confirmVerifyUser: {
    confirmation_code: {
      labelHidden: false,
      label: t("AUTH.CONFIRMATION_CODE_LABEL"),
      placeholder: t("AUTH.CONFIRMATION_CODE_PLACEHOLDER"),
      isRequired: false,
    },
  },
  confirmSignIn: {
    confirmation_code: {
      labelHidden: false,
      label: t("AUTH.CODE_FROM_AUTHENTICATOR_APP_LABEL"),
      placeholder: t("AUTH.ENTER_6_DIGIT_CODE_PLACEHOLDER"),
      isRequired: true,
    },
  },
};

const components = {
  Header,
  SignIn: {
    Header: LoginHeader,
    Footer: LoginFooter
  },
  ConfirmSignIn: {
    Header: () => <h3>{t("AUTH.TWO_FACTOR_AUTHENTICATION")}</h3>,
    Footer: () => <p>{t("AUTH.OPEN_YOUR_AUTHENTICATOR_APP")}</p>
  }
};

  return (
    <>
      <link rel="preconnect" href="https://fonts.googleapis.com" />
      <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
      <link href="https://fonts.googleapis.com/css2?family=Roboto:wght@100;300;400;500&display=swap" rel="stylesheet"></link>
      <ThemeProvider theme={lightModeTheme}>
      <div>
        <Authenticator formFields={formFields} components={components} hideSignUp={true}  className="custom-authenticator-style">
          {({ signOut, user }) => (
            <BrowserRouter>
              <Routes>
                <Route path="/" element={<Navigate replace to="/home" />} />
                <Route path="/home" element={<Home user={user} signOut={signOut} />} />
                <Route path="/subscription-settings" element={<SubscriptionSettings user={user} signOut={signOut}/>} />
                <Route path="/equipment-health-subscription" element={canViewEquipmentHealth(user?.attributes?.email)
                  ? <EquipmentHealthSubscriptionSettings user={user} signOut={signOut}/>
                  : <Navigate replace to="/home" />} />
                <Route path="/mfa-settings" element={<MFASettings user={user} signOut={signOut}/>} />
              </Routes>
            </BrowserRouter>
          )}
        </Authenticator>
      </div>
      </ThemeProvider>
    </>
  );
}
